// extracted by mini-css-extract-plugin
export default {"create":"styles_create__LEhY9","row":"styles_row__w9-YG","col":"styles_col__ialsu","flexRight":"styles_flexRight__hIBzD"};